'use client';

/**
 * Component that wraps children and can be extended to log feature flags to DataDog.
 * Currently no active feature flag logging after table migration cleanup.
 */
export const DatadogFlagsLogger = ({children}: {children: React.ReactNode}) => {
  return <>{children}</>;
};
